import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { BridgesPresence } from "./Player";
import { registerBridgesTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  BridgesDefinition,
  BridgesProgress,
  BridgesSolution,
  BridgesSubmission,
} from "./types";

registerBridgesTranslations(i18n);

export const bridgesModule: PuzzleTypeModule<
  BridgesDefinition,
  BridgesSubmission,
  BridgesProgress,
  BridgesSolution,
  BridgesPresence
> = {
  key: "bridges",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
